import { PayloadAction, createSlice } from '@reduxjs/toolkit'
import { IPolicy } from '../../models/policy'
import { logout, refreshSession, selectRelation } from '../actions/constants'

export interface IPoliciesState {
  policies: IPolicy[]
  policyDetails?: IPolicy
  selectedPolicyNumber?: string
  conceptPolicy?: IPolicy
  isLoadingValueMeter: boolean
  isLoadingInsuranceCard: boolean
  isLoading: boolean
  combiCollectionAmount?: number
}

const initialState: IPoliciesState = {
  policies: [],
  policyDetails: undefined,
  selectedPolicyNumber: undefined,
  conceptPolicy: undefined,
  isLoadingValueMeter: false,
  isLoadingInsuranceCard: false,
  isLoading: false,
  combiCollectionAmount: 0
}

export const policiesSlice = createSlice({
  name: 'policies',
  initialState,
  reducers: {
    setPolicies: (state, action: PayloadAction<IPolicy[]>) => {
      state.policies = action.payload
    },
    updatePolicy: (state, action: PayloadAction<IPolicy>) => {
      state.policies = state.policies.map(policy => {
        if (policy.id === action.payload.id) {
          return action.payload
        }

        return policy
      })
    },
    setValueMeterIsLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoadingValueMeter = action.payload
    },
    setIsLoadingInsuranceCard: (state, action: PayloadAction<boolean>) => {
      state.isLoadingInsuranceCard = action.payload
    },
    setSelectedPolicyNumber: (state, action: PayloadAction<string>) => {
      state.selectedPolicyNumber = action.payload
    },
    setConceptPolicy: (state, action: PayloadAction<IPolicy>) => {
      state.conceptPolicy = action.payload
    },
    setIsPoliciesLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload
    },
    setCombiCollectionAmount: (state, action: PayloadAction<number | undefined>) => {
      state.combiCollectionAmount = action.payload
    },
    setPolicyDetails: (state, action: PayloadAction<IPolicy | undefined>) => {
      state.policyDetails = action.payload
    }
  },
  extraReducers: builder => {
    builder
      .addCase(logout, () => initialState)
      .addCase(selectRelation, () => initialState)
      .addCase(refreshSession, () => initialState)
  }
})

export const {
  setPolicies,
  setPolicyDetails,
  updatePolicy,
  setSelectedPolicyNumber,
  setConceptPolicy,
  setValueMeterIsLoading,
  setIsLoadingInsuranceCard,
  setIsPoliciesLoading,
  setCombiCollectionAmount
} = policiesSlice.actions

export default policiesSlice.reducer
